import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

interface PageHeaderProps {
  title: string;
  imageSrc: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, imageSrc }) => {
  return (
    <section>
      <Container
        fluid
        className="d-flex justify-content-center bg-secondary-subtle"
      >
        <Row>
          <Col sm={5}>
            <img
              src={imageSrc}
              alt={title}
              className="img-fluid w-100"
              style={{ maxHeight: '400px', objectFit: 'cover' }}
            />
          </Col>
          <Col sm={7} className="d-flex align-items-center bg-secondary-subtle">
            <h1 className="fw-bold text-center">{title}</h1>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PageHeader;
